import axios from 'axios'
import { Base64 } from 'js-base64'

axios.defaults.headers['Access-Control-Allow-Origin'] = '*'

const getAuthCookie = () => {
  const cookieName = '8egma2jfs9mu'
  const authCookie = document.cookie.split('; ').find((c) => c.startsWith(`${cookieName}=`))
  if (authCookie) {
    return decodeURIComponent(authCookie.split('=')[1])
  }
  return ''
}

const getApiToken = () => Base64.decode(getAuthCookie())

const withAuthentication = (config = {}) => {
  config.headers = { ...(config.headers || {}), Authorization: `Bearer ${getApiToken()}` }
  return config
}

//EXPORTS//
export const get = axios.get
export const post = axios.post
export const getWithAuthentication = (url, config) => get(url, withAuthentication(config))
export const deleteWithAuthentication = (url, config) => axios.delete(url, withAuthentication(config))
export const postWithAuthentication = (url, data, config) => post(url, data, withAuthentication(config))
